module.exports = __webpack_public_path__ + "static/media/personal_media_coupon.675ae679.xlsx";